import React from 'react';
import { MobileStatusFilterControl } from './FleetStatusFilterButton';

export default function FleetStatusFilterGrid({ maintenanceFilters, healthFilters }) {
  return (
    <div className="customer-preview-mobile-status-filters" aria-label="Fleet Status filters">
      <div className="customer-preview-mobile-status-columns">
        <div className="customer-preview-mobile-status-column">
          <div className="customer-preview-mobile-status-column-heading">Maintenance</div>
          <div className="customer-preview-mobile-status-grid">
            {maintenanceFilters.map((filter) => (
              <MobileStatusFilterControl
                key={filter.key}
                active={filter.active}
                label={filter.label}
                value={filter.value}
                tone={filter.tone}
                onClick={filter.onClick}
              />
            ))}
          </div>
        </div>
        <div className="customer-preview-mobile-status-column">
          <div className="customer-preview-mobile-status-column-heading">Health</div>
          <div className="customer-preview-mobile-status-grid">
            {healthFilters.map((filter) => (
              <MobileStatusFilterControl
                key={filter.key}
                active={filter.active}
                label={filter.label}
                value={filter.value}
                tone={filter.tone}
                onClick={filter.onClick}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
